'use strict';

exports.__esModule = true;
var TWITTER_TAGS = ['TWITTER_TITLE', 'TWITTER_DESCRIPTION', 'TWITTER_IMAGE', 'TWITTER_CARD', 'TWITTER_SITE', 'TWITTER_URL'].reduce(function (acc, curr) {
  acc[curr] = curr;
  return acc;
}, {});

var EXTERNAL_IDENTIFIERS = ['TITLE', 'DESCRIPTION', 'OG_TITLE', 'OG_DESCRIPTION', 'OG_IMAGE', 'FB_ADMINS', 'ROBOTS', 'CANONICAL', 'STRUCTURED_DATA', 'OG_IMAGE_WIDTH', 'OG_IMAGE_HEIGHT'].reduce(function (acc, curr) {
  acc[curr] = curr;
  return acc;
}, {});

var GENERAL_IDENTIFIERS = {
  LINK: 'LINK',
  OG_TAG: 'OG_TAG',
  SATANDARD_META: 'SATANDARD_META'
};

var IDENTIFIERS = Object.assign(['OG_SITE_NAME', 'OG_TYPE', 'OG_URL', 'OG_IMAGE_WIDTH', 'OG_IMAGE_HEIGHT'].reduce(function (acc, curr) {
  acc[curr] = curr;
  return acc;
}, {}), EXTERNAL_IDENTIFIERS, TWITTER_TAGS);

exports.IDENTIFIERS = IDENTIFIERS;
exports.EXTERNAL_IDENTIFIERS = EXTERNAL_IDENTIFIERS;
exports.TWITTER_TAGS = TWITTER_TAGS;
exports.GENERAL_IDENTIFIERS = GENERAL_IDENTIFIERS;